import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearIncidentPopups, reportIncident, resetIncident } from '~/actions';
import useLoading from '../../../../../hooks/useLoading';

export const useReportIncidentPopup = () => {
  const { incident, showReportIncidentPopup, reportIncidentPopupState } = useSelector(
    (state) => state.job,
  );
  const { professionalName, job, incidentType } = incident;

  const dispatch = useDispatch();

  const { isLoading } = useLoading(['REPORT_INCIDENT_ACTION']);

  const submitReportIncident = useCallback(() => {
      const jobId = job?.id;

      if (!jobId) {
        return;
      }

      dispatch(
        reportIncident({
          jobId,
          incidentType,
          name: professionalName,
        }),
      );
    },
    [dispatch, incidentType, job?.id, job?.professional?._id, professionalName],
  );

  const closeReportIncident = useCallback(() => {
    dispatch(clearIncidentPopups());
    dispatch(resetIncident());
  }, [dispatch]);

  return {
    isLoading,
    incident,
    incidentType,
    showReportIncidentPopup,
    submitReportIncident,
    closeReportIncident,
    reportIncidentPopupState,
  };
};
